import { render, staticRenderFns } from "./APITable.vue?vue&type=template&id=628fc7aa&scoped=true&"
import script from "./APITable.vue?vue&type=script&lang=js&"
export * from "./APITable.vue?vue&type=script&lang=js&"
import style0 from "./APITable.vue?vue&type=style&index=0&id=628fc7aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628fc7aa",
  null
  
)

export default component.exports